type PrechatFields = {
  FirstName: string | null | undefined;
  LastName: string | null | undefined;
  UserEmail: string | null | undefined;
};

type InvisibleFields = {
  chnl_UserID?: string;
  chnl_OrderID?: string;
  chnl_OrgID?: string;
  chnl_PartID?: string;
  chnl_QuoteID?: string;
  chnl_UserEmail?: string;
};

// Salesforce chat configuration - single source of truth
// Used by gatsby-ssr.tsx inline loader and initEmbeddedMessaging
export const SF_CHAT_CONFIG = {
  orgId: "00D6A000001kpQd",
  deploymentName: "Main_Chat_Service",
  siteUrl: "https://xometry5836.my.site.com/ESWMainChatService1744206169780",
  scrt2URL: "https://xometry5836.my.salesforce-scrt.com",
  language: "en_US",
} as const;

export const SF_CHAT_BOOTSTRAP_URL = `${SF_CHAT_CONFIG.siteUrl}/assets/js/bootstrap.min.js`;

function initEmbeddedMessaging() {
  try {
    // @ts-expect-error embeddedservice_bootstrap exists on the window
    window.embeddedservice_bootstrap.settings.language = SF_CHAT_CONFIG.language;
    // @ts-expect-error embeddedservice_bootstrap exists on the window
    window.embeddedservice_bootstrap.init(
      SF_CHAT_CONFIG.orgId,
      SF_CHAT_CONFIG.deploymentName,
      SF_CHAT_CONFIG.siteUrl,
      {
        scrt2URL: SF_CHAT_CONFIG.scrt2URL,
      }
    );
  } catch (err) {
    console.error("Error loading Embedded Messaging: ", err);
  }
}

function setPrechatFields(fields: PrechatFields) {
  // @ts-expect-error embeddedservice_bootstrap exists on window
  window?.embeddedservice_bootstrap?.prechatAPI?.setVisiblePrechatFields({
    _firstName: {
      value: fields.FirstName,
      isEditableByEndUser: true,
    },
    _lastName: {
      value: fields.LastName,
      isEditableByEndUser: true,
    },
    _email: {
      value: fields.UserEmail,
      isEditableByEndUser: true,
    },
  });
}

function setInvisibleFields(invisiblefields: InvisibleFields) {
  // @ts-expect-error embeddedservice_bootstrap exists on window
  window?.embeddedservice_bootstrap?.prechatAPI?.setHiddenPrechatFields(
    invisiblefields
  );
}

function setFields(
  prechatfields: PrechatFields,
  invisiblefields: InvisibleFields
) {
  setPrechatFields(prechatfields);
  setInvisibleFields(invisiblefields);
}

function isChatReady() {
  // @ts-expect-error embeddedservice_bootstrap exists!
  return !!window?.embeddedservice_bootstrap?.prechatAPI;
}

export {
  initEmbeddedMessaging,
  isChatReady,
  setFields,
  setInvisibleFields,
  setPrechatFields,
};
